import React from 'react';

const ActionButtons = ({ 
  onSave, 
  onNext, 
  isSaving = false, 
  saveText = 'Save', 
  nextText = 'Next',
  onSubmit = null,
  isSubmitting = false,
  submitText = 'Submit'
}) => {
  return (
    <div className="dash-form-btns">
      {onSave && (
        <button 
          className='dash-form-btn me-2' 
          onClick={onSave}
          disabled={isSaving}
        >
          <i className="fi fi-rr-bookmark me-2"></i>
          {isSaving ? 'Saving...' : saveText}
        </button>
      )}
      
      {onNext && (
        <button className='dash-form-btn' onClick={onNext}>
          {nextText}
        </button>
      )}
      
      {onSubmit && (
        <button 
          className='dash-form-btn' 
          onClick={onSubmit} 
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : submitText}
        </button>
      )}
    </div>
  );
};

export default ActionButtons; 